import { useEffect } from 'react';
import { MoveRight, MoveUpRight, Plus, Send, ThumbsUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import useParent from '../../../hooks/useParent';
import { Input } from '../../../components/ui/input.tsx';

const Event = () => {
  const { currentChild } = useParent();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentChild) {
      navigate('/parent/settings', { state: { label: 'Account Information' } });
    }
  }, [currentChild, navigate]);
  return (
    <section className="px-10 mt-[10vh] py-1">
      <div className="flex justify-between items-center">
        <h2 className="text-[#424242] text-lg font-semibold font-['Inter']">
          Recent Events
        </h2>
        <button className="bg-[#8147e7] rounded-full flex gap-x-2 py-2 px-4 items-center hover:bg-[#643bcb]">
          <Plus size={18} color="#fff" />
          <span className="text-white  font-normal text-sm font-['Inter'] leading-none">
            Add to calendar
          </span>
        </button>
      </div>

      <div className="flex  mt-5 gap-5">
        <div className="flex-[0.49] grid grid-cols-2 gap-5">
          {Array.from({ length: 5 }, (_, index) => {
            if (index === 1) {
              return (
                <div className="flex flex-col justify-between bg-[#6F00DD] rounded-[10px] p-4">
                  <div>
                    <h3 className=" justify-start text-white text-base font-medium font-['Inter']">
                      Science Exhibition for Students
                    </h3>
                    <p className=" justify-start text-[#E9D3FF] text-sm font-normal font-['Inter']">
                      Attention Students, get ready for an exciting opportunity!
                    </p>
                  </div>
                  <div className="flex justify-between items-end">
                    <span>
                      <MoveRight size={40} strokeWidth={1} color="#FFFFFF" />
                    </span>
                    <p className="text-xs">
                      <span class="text-[#C8C8C8] font-normal font-['Inter'] leading-none">
                        Date:
                      </span>
                      <span class="text-white  font-normal font-['Inter'] leading-none">
                        {' '}
                        May 5
                      </span>
                    </p>
                  </div>
                </div>
              );
            }
            return (
              <div className="flex flex-col justify-between bg-white rounded-[10px] p-4">
                <div>
                  <h3 className=" justify-start text-black text-base font-medium font-['Inter']">
                    Book Fair
                  </h3>
                  <p className=" justify-start text-[#2a2a2a] text-sm font-normal font-['Inter']">
                    Attention Students, get ready for an exciting opportunity!
                  </p>
                </div>
                <div className="flex justify-between items-end">
                  <span>
                    <MoveUpRight size={40} strokeWidth={1} />
                  </span>
                  <p className="text-xs">
                    <span class="text-[#9c9c9c] font-normal font-['Inter'] leading-none">
                      Date:
                    </span>
                    <span class="text-black  font-normal font-['Inter'] leading-none">
                      {' '}
                      April 27
                    </span>
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        <div className=" flex-[0.51] py-6 px-10 bg-white rounded-lg">
          <div className="mb-3">
            <p>Date: April 27</p>
            <p className="text-lg">Science Exhibition for Students</p>
          </div>
          <div className="flex gap-x-3">
            <div className="flex-[0.08]">
              <img src="/blackman.png" alt="Poster" className="w-10 h-10" />
            </div>
            <div className="flex-[0.92]">
              <div>
                <p>Tolulope Adedeji</p>
                <p className="text-sm text-[#707070]">Science</p>
              </div>

              <div className="bg-[#F0F0F0] mt-2 py-2.5 px-3.5">
                <p className="text-sm font-semibold mb-1">Book Fair</p>
                <p className="text-sm text-[#707070]">
                  Join us on March 51 for our Bok Fair! Explore captivating
                  reads for the entire family, seize the opportunity ot
                  enrich.Join us on March 51 for our Bok Fair! Explore
                  captivating reads for the entire family.
                </p>
              </div>

              <div className="flex justify-between items-center mt-4 mb-2">
                <div className="flex gap-x-3">
                  <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                    <ThumbsUp size={10} color="#e0c126" fill="#e0c126" />
                    <p className="text-white text-xs">10</p>
                  </div>
                  <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                    <ThumbsUp size={10} color="#e0c126" fill="#e0c126" />
                    <p className="text-white text-xs">10</p>
                  </div>
                  <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                    <ThumbsUp size={10} color="#e0c126" fill="#e0c126" />
                    <p className="text-white text-xs">10</p>
                  </div>
                  <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                    <ThumbsUp size={10} color="#e0c126" fill="#e0c126" />
                    <p className="text-white text-xs">10</p>
                  </div>
                </div>
                <div>
                  <p className="text-[#707070] text-xs">January 27, 1:43pm</p>
                </div>
              </div>

              <p className="text-xs text-[#707070] mb-2">29 Comments</p>

              <div className="border-l border-solid pl-4 overflow-y-scroll max-h-64">
                <div className="flex gap-x-2 mb-3">
                  <img
                    src="/blackman.png"
                    alt="Commenter"
                    className="w-8 h-8 block flex-[0.1] mt-3"
                  />
                  <div>
                    <div className="bg-[#F0F0F0] mt-2 py-2.5 px-3.5">
                      <p className="text-xs font-semibold mb-1">
                        Excited About this
                      </p>
                      <p className="text-xs text-[#707070]">
                        Join us on March 51 for our Bok Fair! Explore
                        captivating reads for the entire family, seize the
                        opportunity ot enrich.Join us on March 51 for our Bok
                        Fair! Explore captivating reads for the entire family.
                      </p>
                    </div>
                    <div className="flex gap-x-3 mt-1">
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">10</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex gap-x-2 mb-3">
                  <img
                    src="/blackman.png"
                    alt="Commenter"
                    className="w-8 h-8 block flex-[0.1] mt-3"
                  />
                  <div>
                    <div className="bg-[#F0F0F0] mt-2 py-2.5 px-3.5">
                      <p className="text-xs font-semibold mb-1">
                        Excited About this
                      </p>
                      <p className="text-xs text-[#707070]">
                        Join us on March 51 for our Bok Fair! Explore
                        captivating reads for the entire family, seize the
                        opportunity ot enrich.Join us on March 51 for our Bok
                        Fair! Explore captivating reads for the entire family.
                      </p>
                    </div>
                    <div className="flex gap-x-3 mt-1">
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">10</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex gap-x-2 mb-3">
                  <img
                    src="/blackman.png"
                    alt="Commenter"
                    className="w-8 h-8 block flex-[0.1] mt-3"
                  />
                  <div>
                    <div className="bg-[#F0F0F0] mt-2 py-2.5 px-3.5">
                      <p className="text-xs font-semibold mb-1">
                        Excited About this
                      </p>
                      <p className="text-xs text-[#707070]">
                        Join us on March 51 for our Bok Fair! Explore
                        captivating reads for the entire family, seize the
                        opportunity ot enrich.Join us on March 51 for our Bok
                        Fair! Explore captivating reads for the entire family.
                      </p>
                    </div>
                    <div className="flex gap-x-3 mt-1">
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">10</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex gap-x-2 mb-3">
                  <img
                    src="/blackman.png"
                    alt="Commenter"
                    className="w-8 h-8 block flex-[0.1] mt-3"
                  />
                  <div>
                    <div className="bg-[#F0F0F0] mt-2 py-2.5 px-3.5">
                      <p className="text-xs font-semibold mb-1">
                        Excited About this
                      </p>
                      <p className="text-xs text-[#707070]">
                        Join us on March 51 for our Bok Fair! Explore
                        captivating reads for the entire family, seize the
                        opportunity ot enrich.Join us on March 51 for our Bok
                        Fair! Explore captivating reads for the entire family.
                      </p>
                    </div>
                    <div className="flex gap-x-3 mt-1">
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">10</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex gap-x-2 mb-3">
                  <img
                    src="/blackman.png"
                    alt="Commenter"
                    className="w-8 h-8 block flex-[0.1] mt-3"
                  />
                  <div>
                    <div className="bg-[#F0F0F0] mt-2 py-2.5 px-3.5">
                      <p className="text-xs font-semibold mb-1">
                        Excited About this
                      </p>
                      <p className="text-xs text-[#707070]">
                        Join us on March 51 for our Bok Fair! Explore
                        captivating reads for the entire family, seize the
                        opportunity ot enrich.Join us on March 51 for our Bok
                        Fair! Explore captivating reads for the entire family.
                      </p>
                    </div>
                    <div className="flex gap-x-3 mt-1">
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">10</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                      <div className="flex gap-x-1 items-center bg-black px-3 py-1 rounded-full">
                        <ThumbsUp size={9} color="#e0c126" fill="#e0c126" />
                        <p className="text-white text-xs">9</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-x-2 mt-3">
            <Input
              placeholder="Type a message"
              className="bg-[#EBEAEA] rounded-full"
            />
            <button className="bg-[#8147e7] w-11 h-10 flex rounded-full justify-center items-center  hover:bg-[#643bcb]">
              <Send color="#fff" strokeWidth={2} size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Event;
